import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { LangProvider } from "@/lib/i18n";
import { SmoothScroll } from "@/lib/SmoothScroll";

function App() {
  return (
    <div className="App grain">
      <LangProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </SmoothScroll>
        </BrowserRouter>
        <Toaster
          theme="light"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#fbf6ea",
              color: "#0e1f1b",
              border: "1px solid rgba(14,31,27,0.14)",
            },
          }}
        />
      </LangProvider>
    </div>
  );
}

export default App;
